// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.edit-product-modal-modal_card-nlEt9 {
  width: 340px;
  height: auto;
  min-height: 340px;
}

.edit-product-modal-textField_container-qOsGX, .edit-product-modal-select-F6LX0 {
  width: 100%;
  margin-top: 24px;
}
`, "",{"version":3,"sources":["webpack://./src/pages/customer/customer-products/edit-product-modal/edit-product-modal.module.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB","sourcesContent":[".modal_card {\n  width: 340px;\n  height: auto;\n  min-height: 340px;\n}\n\n.textField_container, .select {\n  width: 100%;\n  margin-top: 24px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modal_card": `edit-product-modal-modal_card-nlEt9`,
	"textField_container": `edit-product-modal-textField_container-qOsGX`,
	"select": `edit-product-modal-select-F6LX0`
};
export default ___CSS_LOADER_EXPORT___;
